module.exports = __webpack_public_path__ + "img/data-server-2.374c614.png";